export default {
    baseUrl: 'https://api.air-vote.com',
    isDev: false,
    siteUrl: 'https://air-vote.com',
    STATIC_MAP_API_KEY: 'AIzaSyBRbSm7ZE5ofSJxHan56oyF9tr9SxXcHw4',
    url: 'https://my.air-vote.com/',
}
